import { render } from "./ActivityBudgetTable.vue?vue&type=template&id=36a90a2a&scoped=true&ts=true"
import script from "./ActivityBudgetTable.ts?vue&type=script&lang=ts"
export * from "./ActivityBudgetTable.ts?vue&type=script&lang=ts"

import "./ActivityBudgetTable.scss?vue&type=style&index=0&id=36a90a2a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a90a2a"]])

export default __exports__